module.exports = __webpack_public_path__ + "img/emptylist.3f41cb60.svg";